import { Navigate, Outlet } from "react-router-dom";

const LoggedInPrivateRoutes = () => {
  let tokenFromLocalStorage = localStorage.getItem("token");
  const navigateTo = window.location.pathname.includes("sign")
    ? "/"
    : window.location.pathname;
  return !tokenFromLocalStorage ? <Outlet /> : <Navigate to={navigateTo} />;
};

export { LoggedInPrivateRoutes };
